import { GetterTree } from "vuex";
import { IProductionLineState } from "./state";
import {
    IProductionLine,
    IWorkOrder,
    IWorkOrderComponent,
    IWorkOrderMission,
    WorkOrderStatus,
    CleaningType,
    ICleaning,
} from "@/models";

export const getters: GetterTree<IProductionLineState, any> = {

    getProductionLineById: (state) => (productionLineId: number): IProductionLine => {
        return state.productionLines.find(pl => pl.productionLineId === productionLineId);
    },

    getWorkOrdersByProductionLine: (state) => (productionLineId: number): IWorkOrder[] => {
        return state.workOrders.filter(wo => wo.productionLineId === productionLineId);
    },

    getProductionLineStartedWorkOrder: (state) => (productionLineId: number): IWorkOrder => {
        return state.workOrders.find(wo => wo.productionLineId === productionLineId && wo.status === WorkOrderStatus.Started);
    },

    getProductionLineReturnWorkOrder: (state) => (productionLineId: number): IWorkOrder => {
        return state.workOrders.find(wo => wo.productionLineId === productionLineId && wo.status === WorkOrderStatus.Return);
    },

    getWorkOrderById: (state) => (workOrderId: number): IWorkOrder => {
        return state.workOrders.find(wo => wo.workOrderId === workOrderId);
    },

    getNextWorkOrder: (state) => (workOrder: IWorkOrder): IWorkOrder => {
        return state.workOrders.find(wo => wo.productionLineId === workOrder.productionLineId && wo.estimatedStartDate > workOrder.estimatedStartDate);
    },

    getWorkOrderComponentById: (state) => (workOrderComponentId: number): IWorkOrderComponent => {
        for (const workOrder of state.workOrders) {
            const woComponent = workOrder.workOrderComponents.find(woc => woc.workOrderComponentId === workOrderComponentId);
            if (woComponent) {
                return woComponent;
            }
        }
        return null;
    },

    getWorkOrderMissions: (state) => (): IWorkOrderMission[] => {
        let woMissions = [];
        for (const workOrder of state.workOrders) {
            woMissions = woMissions.concat(workOrder.workOrderMissions);
        }
        return woMissions.sort((a: IWorkOrderMission, b: IWorkOrderMission) => new Date(a.creationDate).getTime() - new Date(b.creationDate).getTime());
    },

    getWorkOrderMissionById: (state) => (workOrderMissionId: number): IWorkOrderMission => {
        for (const workOrder of state.workOrders) {
            const woMission = workOrder.workOrderMissions.find(wom => wom.workOrderMissionId === workOrderMissionId);
            if (woMission) {
                return woMission;
            }
        }
        return null;
    },

    getProductionLineWorkOrderMissions: (state) => (productionLineId: number): IWorkOrderMission[] => {
        let woMissions = [];
        for (const workOrder of state.workOrders.filter(wo => wo.productionLineId === productionLineId)) {
            woMissions = woMissions.concat(workOrder.workOrderMissions);
        }
        return woMissions;
    },

    getLastCleaning: (state) => (type: CleaningType): ICleaning => {
        return state.lastCleanings.find(cleaning => cleaning.type === type);
    },

};
